module.exports = __webpack_public_path__ + "static/media/Hours45.7f8ad20c.png";